import { render, staticRenderFns } from "./card-grid-structured.vue?vue&type=template&id=bc3b92d2&scoped=true"
import script from "./card-grid-structured.vue?vue&type=script&lang=js"
export * from "./card-grid-structured.vue?vue&type=script&lang=js"
import style0 from "./card-grid-structured.vue?vue&type=style&index=0&id=bc3b92d2&prod&scoped=true&lang=css"
import style1 from "./card-grid-structured.vue?vue&type=style&index=1&id=bc3b92d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3b92d2",
  null
  
)

export default component.exports